import { useDispatch } from "react-redux";
import Xarrow from "react-xarrows";
import { importFromYaml } from "../../../../abstract/controller/modelYamlImport";
import { useArrowSync } from "../../../../abstract/hook/useArrowSync";
import { setRoot } from "../../../../abstract/redux/slice/structureSlice";
import ButtonIntroWide from "../../../ui/buttons/ButtonIntroWide";
import ButtonTomatoClose from "../../../ui/buttons/ButtonTomatoClose";
import * as tutorialUtils from "../../../../abstract/controller/utils/tutorialUtils";
import styles from "./Manual.module.scss";

const id = "firstFunction3";
const idNext = "firstFunction4";
const idPrev = "firstFunction2";

const next = `
functions:
  - function: Duel
    parameters:
      - parameter: Protagonist
      - parameter: Antagonist
      - parameter: Weapon
      - parameter: Location
`;

const prev = `
functions:
  - function: Duel
`;

function ManualFirstFunction3({ tutorial, setTutorial }) {
  if (tutorial === id) {
    return <Core setTutorial={setTutorial} />;
  }

  return null;
}

function Core({ setTutorial }) {
  const _dispatch = useDispatch();
  const renderTrigger = useArrowSync();

  const handleShowMe = () => {
    const { model } = importFromYaml(next);
    _dispatch(setRoot(model, 0));
  };

  const handleBack = () => {
    const { model } = importFromYaml(prev);
    _dispatch(setRoot(model, 0));
    setTutorial(idPrev);
  };

  const handleClose = () => {
    setTutorial("null");
  };

  return (
    <>
      {document.getElementById("add_input_parameter") && (
        <div className={`${styles["container"]} ${styles["container-ff3"]} ${styles["overlay"]}`}>
          <div
            id="tutorial-text-2"
            className={`${styles["container__text"]} ${styles["container__text-2"]}`}>
            <p>Click here to add a few more parameters, namely:</p>
            <p>
              <b>Antagonist</b>, <b>Weapon</b>, <b>Location</b>.
            </p>
          </div>

          <Xarrow
            key={`arrow-3-${renderTrigger}`}
            start="tutorial-text-2"
            end="add_input_parameter"
            color="#415B32"
            strokeWidth={2}
            path="smooth"
            curveness={0.8}
            headSize={6}
          />
        </div>
      )}

      <div className={`${styles["foreground"]} ${styles["foreground-ff3"]} ${styles["overlay"]}`}>
        <ButtonTomatoClose onClick={handleClose} />
        <div className={styles["header"]}>
          <div className={styles["header__assistant"]}></div>
          <div className={styles["header__text--main"]}>
            <p>Now, let's add three more parameters.</p>
          </div>
        </div>
        <div className={styles["confirmation"]}>
          <div className={styles["button"]}>
            <ButtonIntroWide theme="red" title="Go back!" onClick={handleBack} />
          </div>
          <div className={styles["button"]}>
            <ButtonIntroWide theme="tomato" title="Show me!" onClick={handleShowMe} />
          </div>
        </div>
      </div>
    </>
  );
}

export const manualValidateFirstFunction3 = (root, tutorial, setTutorial, setMessage) => {
  if (tutorial === id) {
    let { res: resFun, msg: msgFun } = tutorialUtils.validateSingleFunction(root, "Duel");

    if (!resFun) {
      setMessage(msgFun);
      return false;
    }

    let { res: resParam, msg: msgParam } = tutorialUtils.validateParameters(
      root,
      "root→[function]→Duel",
      ["Protagonist", "Antagonist", "Weapon", "Location"],
    );

    if (!resParam) {
      setMessage(msgParam);
      return false;
    }

    setTutorial(idNext);

    setMessage("");
    return true;
  }

  return false;
};

export default ManualFirstFunction3;
